import { offset, addClass } from '../../../../../../utils/dom'

import {
  changeMode,
  MODE_TYPES,
  MODE,
  isDom
} from './shared'

import createBar from './bar'

// 当前配置
const BAR_MAP = {
  vertical: {
    OFFSETSIZE: 'offsetHeight',
    scroll: 'scrollTop',
    SCROLLSIZE: 'scrollHeight',
    size: 'height',
    key: 'vertical',
    axis: 'Y',
    client: 'clientY',
    direction: 'top'
  },
  horizontal: {
    OFFSETSIZE: 'offsetWidth',
    scroll: 'scrollLeft',
    SCROLLSIZE: 'scrollWidth',
    size: 'width',
    key: 'horizontal',
    axis: 'X',
    client: 'clientX',
    directionX: 'left',
    directionY: 'bottom',
    assistDirection: 'top',
    assistSize: 'height'
  }
}

function getFixedBottomVal () {
  const fixedBottom = window.fe?.fixedBottom?.[0]
  return (fixedBottom && fixedBottom.key === 'bottomFixed') ? fixedBottom.height : 0
}

// 绑定初始化
function _init (options) {
  changeMode(MODE_TYPES.WAIT)
  const { $el, BAR_CONFIG } = options
  let $elBar = null // 当前滚动条
  // let visibilityRegion // 开始区域大小
  let _this = this
  let isFixedBottom = getFixedBottomVal() > 0

  const {
    OFFSETSIZE,
    SCROLLSIZE,
    key: BARKEY,
    scroll: SCROLL,
    axis
  } = BAR_CONFIG

  // 事件管理
  const EVENTFN = {
    handleMouseenter () {
      // visibilityRegion = getCurClient()
      const { [OFFSETSIZE]: offsetSize, [SCROLLSIZE]: scrollSize } = $el
      if (offsetSize >= scrollSize) {
        return
      }
      if ($elBar === null) {
        $elBar = createBar($el, BARKEY, $el, BAR_CONFIG)
        _this.$elBar = $elBar
        _this.signNode = _this.createdSign($elBar)
      }
      const { y } = _this.signNode.getBoundingClientRect()
      _this.isIntersecting = window.innerHeight - getFixedBottomVal() > y
      // 改变可是窗口大小 更新滚动条位置
      _this.computed()
      // computed()
      /* 更新宽度 */
      $elBar.firstChild.style.width = `${(offsetSize / scrollSize) * 100}%`
      $elBar.style.width = `${offsetSize}px`
      changeMode(
        MODE === MODE_TYPES.DOWN ? MODE_TYPES.SHOW_DOWN : MODE_TYPES.SHOW
      )
      $elBar.changeScrollState('visible')
    },
    handleMouseleave () {
      if (MODE === MODE_TYPES.SHOW) {
        changeMode(MODE_TYPES.WAIT)
        $elBar.changeScrollState()
        return
      }
      changeMode(MODE_TYPES.DOWN)
    },
    handleScroll (event) {
      if (event.target === $el) {
        const dom = $elBar?.firstChild
        const { [OFFSETSIZE]: offsetSize, [SCROLL]: scroll } = event.target
        if (dom) {
          dom.style.transform = `translate${axis}(${(scroll * 100) / offsetSize}%)`
          dom.style['msTransform'] = `translate${axis}(${(scroll * 100) / offsetSize}%)`
        }         
      }
      options.onScroll && options.onScroll(event)
    },
    // 当前模式为show时滚动同步滚动条位置
    hanldeWindowScroll () {
      if (MODE === 'SHOW' && _this.signNode) {
        const { y } = _this.signNode.getBoundingClientRect()
        _this.isIntersecting = window.innerHeight - getFixedBottomVal() > y
        _this.computed()
      }
    },
    handleWindowResize () {
      EVENTFN.handleMouseenter()
    }
  }

  function bindEvent () {
    $el.addEventListener('scroll', EVENTFN.handleScroll)
    $el.addEventListener('mouseenter', EVENTFN.handleMouseenter)
    $el.addEventListener('mouseleave', EVENTFN.handleMouseleave)
    if (isFixedBottom) {
      document.addEventListener('scroll', EVENTFN.hanldeWindowScroll)      
    }
    document.addEventListener('resize', EVENTFN.handleWindowResize)
  }

  function destroyedEvent () {
    // 组件销毁时删除dom
    $elBar && $el.removeChild($elBar)
    $el.addEventListener('scroll', EVENTFN.handleScroll)
    $el.removeEventListener('mouseenter', EVENTFN.handleMouseenter)
    $el.removeEventListener('mouseleave', EVENTFN.handleMouseleave)
    if (isFixedBottom) {
      document.removeEventListener('scroll', EVENTFN.hanldeWindowScroll)
    }
    document.removeEventListener('resize', EVENTFN.handleWindowResize)
    _this.$observer && _this.$observer._unobserve()
  }

  return {
    bindEvent,
    destroyedEvent
  }
}

export default class ScrollBar {
  constructor (el, options = { type: 'horizontal' }) {
    if (!isDom(el)) {
      throw new Error('params error: el is required')
    }
    this.$el = el
    this.$options = options   
    this.init()
  }

  computed () {
    if (!this.$elBar) {
      return
    }
    let fixedBottomVal = getFixedBottomVal()
    const $elBar = this.$elBar
    if (this.isIntersecting) {
      $elBar.style.position = ``
      $elBar.style['bottom'] = ``
      $elBar.style['left'] = ``
    } else {
      const { left } = offset(this.$el)
      $elBar.style.position = 'fixed'
      $elBar.style['left'] = `${left}px`
      $elBar.style['bottom'] = `${fixedBottomVal}px`
    }
  }

  createdSign ($elBar) {
    const signNode = document.createElement('div')
    addClass(signNode, 'sy-scroll-bar-sign')
    this.$el.appendChild(signNode)
    if (getFixedBottomVal() === 0) {
      this.$observer = new IntersectionObserver((entrys) => {
        for (const v of entrys) {
          if (!$elBar) {
            return
          }
          this.isIntersecting = v.isIntersecting
          this.computed($elBar)
        }
      }, {
        root: null,
        rootMargin: '0px',
        threshold: 0.0
      })
      this.$observer.observe(signNode)
      this.$observer._unobserve = () => {
        this.$observer.unobserve(signNode)
      }
    }
    return signNode
  }

  init () {
    const { type } = this.$options
    const BAR_CONFIG = BAR_MAP[type]
    const { bindEvent, destroyedEvent } = _init.call(this, {
      BAR_CONFIG,
      $el: this.$el
    })
    bindEvent.call(this)
    this.destroyed = destroyedEvent
  }
}
